import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Ic_add from "../../../assets/images/icons/add-square.svg";
import emptyAppointment from "../../../assets/images/icons/appointment-empty.svg";
import calendarAppointment from "../../../assets/images/icons/calendarAppointment.svg";
import { GeneralButton } from "../../../components";
import { EndPoints } from "../../../Constants/endpoints";
import { useGetData } from "../../../hooks";
import useAppMediaQuery from "../../../hooks/window/useAppMediaQuery";
import { IAppointment } from "../../../interface/appointmentInterfaces";
import { IsProfileCompleted } from "../../../Share"; 
import { MyAppointmentCard, MyAppointmentCardLoader } from "../../Appointments/component";

const MyAppointmentsCards: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isMobileOrTablet } = useAppMediaQuery();
  const { data, isLoading, error, refetch } = useGetData<IAppointment[]>(
    EndPoints.GetHomeAppointments,
    {
      filter: { Count: 10 },
    },
  );

  const renderContent = () => {
    if (isLoading) {
      return Array.from({ length: 3 }).map((_, index) => (
        <MyAppointmentCardLoader key={index} />
      ));
    }

    if (error) {
      return (
        <div className="flex flex-col items-center py-4">
          <p className="text-error">
            {t("error_loading_data")}: {error.message}
          </p>
          <button
            onClick={() => refetch()}
            className="mt-2 rounded bg-primary px-4 py-2 text-white"
          >
            {t("retry")}
          </button>
        </div>
      );
    }

    if (data && data.Data.length === 0) {
      return (
        <div className="flex h-full flex-col items-center justify-center py-4">
          <img src={emptyAppointment} alt="empty appointment" />
          <p className="text-body-text">{t("no_appointments_found")}.</p>
        </div>
      );
    }

    return (
      <div className="grid gap-4">
        {data?.Data?.map((appointment: IAppointment) => (
          <MyAppointmentCard key={appointment.Id} appointment={appointment} />
        ))}
      </div>
    );
  };

  return (
    <div className="box flex h-full w-full grow flex-col gap-4 overflow-hidden rounded bg-white !p-4">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center justify-center gap-2 md:gap-4">
          <img className="h-10 w-10" src={calendarAppointment} alt="" />
          <p className="font-bold">{t("appointment")}</p>
        </div>
        <div className="flex items-center gap-2">
          <GeneralButton
            color="lite"
            route="/appointments"
            title={isMobileOrTablet ? t("see_all") : t("see_all_appointments")}
          />
          <IsProfileCompleted
            onAllowedClick={() => navigate("/appointments/add_new_appointment")}
          >
            <GeneralButton
              icon={Ic_add}
              className="!px-4"
              title={t("add_new_appointment")}
            />
          </IsProfileCompleted>
        </div>
      </div>
      <div className="max-h-[48                dvh] xl:max-h-[90%] flex-1 overflow-auto">{renderContent()}</div>
    </div>
  );
};

export default MyAppointmentsCards;
